// extracted by css-extract-rspack-plugin
export default {"selectorButton":"ModeSelector-module__selectorButton__dyfY5"};